import { Component, Input } from '@angular/core';

import { WidgetSectionCms } from '~/cms/interfaces/homepage.cms.interface';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-cms-widget-section',
  templateUrl: './widget-section.component.html',
  styleUrls: ['./widget-section.component.scss'],
})
export class CmsWidgetSectionComponent {
  @Input() public section: WidgetSectionCms;

  public readonly iconTypeEnum = VtmnPlayIconTypeEnum;
}
